/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmailVerificationData { 
    /**
     * token which contains user information
     */
    token?: string;
    /**
     * verification code
     */
    verificationCode?: string;
}

